









































































































































































































































































//@ts-ignore
import pdf from 'vue-pdf'
import { format } from 'date-fns'
import { mapGetters } from 'vuex'
import { AxiosResponse } from 'axios'
import { coreKaizen } from '@/common/coreKaizen'
import { Component, Prop } from 'vue-property-decorator'
import { certificacionModel } from '@/models/certificaciones/certificacionModel';
import { ticketLogModel } from '@/models/kaizen/ticketLogModel';
import router from '@/router';
import { tipoEntidadModel } from '@/models/certificaciones/tipoEntidadModel'
import { tipoCertificacionModel } from '@/models/certificaciones/tipoCertificacionModel'
import fileViewer from './fileViewer.vue'

const namespace: string = 'oidcStore/';
@Component({
    components: {
        pdf,
        fileViewer
    },
    computed: {
        ...mapGetters(namespace, [
            'oidcIdToken'
        ])
    }
})
export default class autorizaCerti extends coreKaizen {
    @Prop(String) ticket!: string
    @Prop(String) pageTitle!: string
    @Prop(Number) behavior!: number

    emptyEntidad: certificacionModel = {
        boleta: 0,
        certificacion: { correlativo: 0, ejercicio: 0 },
        registro: '',
        folio: 0,
        libro: 0,
        descripcion: '',
        expediente: { correlativo: 0, ejercicio: 0 },
        extranjera: false,
        fechaPublicacion: new Date(),
        fechaTra: new Date(),
        fechaTra2: new Date(),
        organizacion: '',
        solicitante: { nombre: '', telefono: '', direccion: '', dpi: '', e_mail: '' },
        ticket: 0,
        tipoCertificacion: 0,
        tipoEntidad: 0,
        titular: { numero: '', tipo: '' },
        referenceData: {
            dataFound: false, items: [
                {
                    titular: { numero: '', tipo: '' },
                    expediente: { correlativo: 0, ejercicio: 0 },
                    extranjera: false,
                    registro: '',
                    folio: 0,
                    libro: 0,
                    id: '',
                    name: '',
                    props: []
                }
            ]
        }
    }
    tipoCertificacion: string = ''
    tipoEntidad: string = ''
    entidad: certificacionModel = this.emptyEntidad
    montoHint: string = "Ingrese el monto adicional que se debe cancelar para emitir la certificaci\u{f3}n sin comas"
    montoAdicional: number = 0
    descripcion: string = ''
    pagoAdicionalDialog: boolean = false
    devuelveCertificacion: boolean = false
    rechazoDialog: boolean = false
    RFLRules: any = [(v: string) => !!v || 'Campo requerido']
    fileNames: string[] = [];
    currentPage: number = 1
    pageCount: number = 0
    downloadingCertificacion: boolean = false
    loadingTask: any = null
    loadedDocument: boolean = false
    snackBarText: string = ''
    snackbar: boolean = false
    isLoading: boolean = false
    isPosting: boolean = false
    documentSigned: boolean = false
    ticketLog: ticketLogModel[] = []

    mounted() {
        this.getTicketData()
        this.getTicketLog()
        this.getFile()
    }

    get behaviorAuthorization() {
        return this.behavior === 1
    }

    get behaviorSignature() {
        return this.behavior === 2
    }

    get styleDocument(): string {
        return this.loadedDocument === true ? "display:inline-block; width: 100%; border: 1px solid red" : "display:none"
    }

    get sourceFile(): string {
        return `${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.ticket}/adjuntos/certificacionCompleta.pdf`;
    }

    get hasLibro(): boolean {
        if (this.entidad.libro && this.entidad.libro > 0) {
            return true
        }
        return false;
    }

    get hasExpediente(): boolean {
        if (this.entidad.expediente) {
            return true
        }
        return false
    }

    get hasTitular(): boolean {
        if (this.entidad.titular && this.entidad.titular.numero) {
            return true
        }
        return false
    }

    get showDPI(): boolean {
        return (this.entidad.tipoEntidad === 7)
    }

    get sourceDPIFile(): string {
        return `${process.env.VUE_APP_BACKEND_HOST}/certificaciones/${this.ticket}/adjuntos/dpi`;
    }

    dateFormat(value: Date): string {
        return format(value, 'DD-MM-YYYY hh:mm:ss aa')
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.currentPage--
        }
    }

    nextPage() {
        if (this.currentPage < this.pageCount) {
            this.currentPage++
        }
    }

    tituloEntidad(name: string, id: string): string {
        return name + ' - ' + id
    }

    getTiposCertificacion() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoCertificacion')
            .then(r => r as AxiosResponse<tipoCertificacionModel[]>)
            .then(d => {
                this.tipoCertificacion = (d.data.find(x => x.tipoCertificacion === this.entidad.tipoCertificacion) || { tipoCertificacion: 0, nombre: '' }).nombre
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTiposEntidad() {
        this.isLoading = true
        this.GilgameshApi.get('certificaciones/tipoEntidad')
            .then(r => r as AxiosResponse<tipoEntidadModel[]>)
            .then(d => {
                this.tipoEntidad = (d.data.find(x => x.tipoEntidad === this.entidad.tipoEntidad) || { tipoEntidad: 0, nombre: '' }).nombre
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    getTicketData() {
        if (this.ticket) {
            this.isLoading = true
            this.GilgameshApi.get(`certificaciones/${this.ticket}`)
                .then(r => r as AxiosResponse<certificacionModel>)
                .then(d => {
                    this.entidad = d.data
                    return this.getTiposEntidad()
                }).then(() => {
                    return this.getTiposCertificacion()
                })
                .catch(x => console.log('reason: ' + x))
                .finally(() => this.isLoading = false)
        }
    }

    getTicketLog() {
        this.isLoading = true
        this.GilgameshApi.get(`certificaciones/${this.ticket}/history`)
            .then(r => r as AxiosResponse<ticketLogModel[]>)
            .then(d => {
                this.ticketLog = d.data
                if (this.ticketLog && this.ticketLog.length > 0) {
                    this.ticketLog.forEach((x, i, m) => {
                        if (i === 0) {
                            x.icon = 'star'
                            x.color = 'red lighten-2'
                        }
                        else if (i < m.length - 1) {
                            x.icon = 'assignment'
                            x.color = 'lime darken-2'
                        }
                        else {
                            x.icon = 'assignment'
                            x.color = 'indigo'
                        }
                    })
                }
            })
            .catch(x => console.log('reason: ' + x))
            .finally(() => this.isLoading = false)
    }

    sourceFilePDF() {
        const token = this.$store.getters[namespace + 'oidcIdToken'];
        return {
            url: this.sourceFile,
            withCredentials: false,
            httpHeaders: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + token
            }
        }
    }

    getFile() {
        this.downloadingCertificacion = true
        this.loadingTask = pdf.createLoadingTask(this.sourceFilePDF())
        this.loadingTask.then((pdf: any) => {
            this.pageCount = pdf.numPages;
            this.loadedDocument = true
            this.currentPage = 1
        }).catch((x: any) => console.log('reason: ' + x))
            .finally(() => this.downloadingCertificacion = false);
    }

    pagoAdicional() {
        this.pagoAdicionalDialog = true
    }

    rechazaCerti() {
        this.devuelveCertificacion = false
        this.rechazoDialog = true
    }

    devuelveCerti() {
        this.devuelveCertificacion = true
        this.rechazoDialog = true
    }

    autorizaCerti() {
        if (!this.isPosting) {
            this.isPosting = true
            const msg = { outcome: 2, annotation: this.descripcion }
            this.GilgameshApi.put(`certificaciones/${this.ticket}/aproveOutcome`, msg)
                .then(r => {
                    if (r.status === 200) {
                        this.snackbar = true
                        this.snackBarText = "Se ha enviado a firma la solicitud"
                    }
                })
                .catch((x: any) => console.log('reason: ' + x))
                .finally(() => {
                    this.isPosting = false
                    setTimeout(function () {
                        router.push({ name: 'kanban' })
                    }, 4000)
                })
        }
    }

    rechazarCerti() {
        if (!this.isPosting) {
            this.isPosting = true
            let outcome: number = this.devuelveCertificacion === false ? 3 : 4;
            this.rechazoDialog = false
            const msg = { outcome: outcome, annotation: this.descripcion }
            this.GilgameshApi.put(`certificaciones/${this.ticket}/aproveOutcome`, msg)
                .then(r => {
                    if (r.status === 200) {
                        this.snackbar = true
                        this.snackBarText = "Se ha devuelto la solicitud al operador para que rectifique"
                    }
                })
                .catch((x: any) => console.log('reason: ' + x))
                .finally(() => {
                    this.isPosting = false
                    this.rechazoDialog = false
                    setTimeout(function () {
                        router.push({ name: 'kanban' })
                    }, 4000)
                })
        }
    }

    pagoRequerido() {
        if (!this.isPosting) {
            this.isPosting = true
            this.pagoAdicionalDialog = false
            const msg = { outcome: 1, extraAmount: this.montoAdicional, annotation: this.descripcion }
            this.GilgameshApi.put(`certificaciones/${this.ticket}/aproveOutcome`, msg)
                .then(r => {
                    if (r.status === 200) {
                        this.snackbar = true
                        this.snackBarText = "Se ha notificado al solicitante que efectue el pago"
                    }
                })
                .catch((x: any) => console.log('reason: ' + x))
                .finally(() => {
                    this.isPosting = false
                    this.rechazoDialog = false
                    setTimeout(function () {
                        router.push({ name: 'kanban' })
                    }, 4000)
                })
        }
    }

    activarFirmaElectronica() {
        location.href = "dsign://firma-e"
    }

    firmarCertificacion() {
        if (!this.isPosting) {
            this.isPosting = true
            this.GilgameshApi.put(`certificaciones/${this.ticket}/sign`)
                .then(r => {
                    if (r.status === 200) {
                        this.snackbar = true
                        this.snackBarText = "Se ha firmado el documento, recuperando el documento con firma digital"
                        this.getFile()
                    }
                })
                .catch((x: any) => console.log('reason: ' + x))
                .finally(() => {
                    this.isPosting = false
                    this.documentSigned = true
                    setTimeout(function () {
                        router.push({ name: 'kanban' })
                    }, 2000)
                })
        }
    }

    gotoKanban() {
        router.push({ name: 'kanban' })
    }
}
